import React from 'react';
import { classes } from '../../utils/Styles';

const billitLogoSrc = `${process.env.PUBLIC_URL || ''}/billit.svg`;

/** Billit brand mark for sidebar navigation (matches Fluent icon slot ~20px). */
const BillitNavIcon = () => (
  <span
    className={classes.icon}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 20,
      minWidth: 20,
      height: 20,
      flexShrink: 0,
    }}
  >
    <img
      src={billitLogoSrc}
      alt=''
      width={18}
      height={18}
      style={{ display: 'block', objectFit: 'contain' }}
      aria-hidden
    />
  </span>
);

export default BillitNavIcon;
